module.exports = __webpack_public_path__ + "static/media/attachment.bd91baab.svg";